import { stringify } from 'qs'
import assert from './assert'

/**
 * Used within the global nav to highlight the Personas nav item.
 */
export const personasPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas`
}

export const personasCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/new`
}

export const personasExplorerPath = args => {
  assert(args, 'workspaceSlug')
  const path = `/${args.workspaceSlug}/personas/explorer`

  if (args.query) {
    assert(args.query, 'accounts')

    if (args.query.accounts) {
      const query = stringify({
        accounts: args.query.accounts
      })

      return `${path}?${query}`
    }
  }

  return path
}

export const personasExplorerRecordPath = args => {
  assert(args, ['workspaceSlug', 'recordId'])
  const path = `/${args.workspaceSlug}/personas/explorer/${args.recordId}`

  if (args.query) {
    assert(args.query, 'accounts')

    if (args.query.accounts) {
      const query = stringify({
        accounts: args.query.accounts
      })

      return `${path}?${query}`
    }
  }

  return path
}

export const personasDestinationsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/destinations`
}

export const personasDestinationSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/destinations/${args.destinationId}`
}

export const personasTraitsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/traits`
}

export const personasTraitsCreatePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/traits/new`
}

export const personasTraitPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/overview`
}

export const personasTraitBuilderPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/edit`
}

export const personasTraitSettingsPath = args => {
  assert(args, ['workspaceSlug', 'traitId'])
  return `/${args.workspaceSlug}/personas/traits/${args.traitId}/settings`
}

export const personasAudiencesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/audiences`
}

export const personasAudiencesCreatePath = args => {
  assert(args, 'workspaceSlug')
  const path = `/${args.workspaceSlug}/personas/audiences/new`

  if (args.query) {
    assert(args.query, 'templates')

    const query = stringify({
      templates: args.query.templates
    })

    return `${path}?${query}`
  }

  return path
}

export const personasAudienceOverviewPath = args => {
  assert(args, 'workspaceSlug')
  assert(args, 'audienceId')
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/overview`
}

export const personasAudienceBuilderPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/edit`
}

export const personasAudienceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'audienceId'])
  return `/${args.workspaceSlug}/personas/audiences/${args.audienceId}/settings`
}

export const personasSettingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings`
}

export const personasSettingsSourcesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings/sources`
}

export const personasSettingsAPIAccessPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/personas/settings/api-access`
}
